<template>
  <div class="users-list row g-3">
    <template v-if="loading">
      <div
        v-for="n in 6"
        :key="'skeleton-' + n"
        class="col-12 col-md-6 col-lg-4"
      >
        <div class="card shadow-sm user-card h-100 p-3">
          <div class="d-flex align-items-start gap-3">
            <div
              class="rounded-circle bg-secondary placeholder-glow user-avatar"
            ></div>

            <div class="flex-grow-1">
              <div class="placeholder-glow mb-2">
                <span class="placeholder col-7"></span>
              </div>
              <div class="placeholder-glow mb-1">
                <span class="placeholder col-10"></span>
              </div>
              <div class="placeholder-glow mb-1">
                <span class="placeholder col-6"></span>
              </div>
              <div class="placeholder-glow">
                <span class="placeholder col-8"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <div
        v-for="user in users"
        :key="user.id"
        class="col-12 col-md-6 col-lg-4"
      >
        <div
          class="card shadow-sm user-card h-100 position-relative"
          :class="rolePatternClass(user.role.name)"
        >
          <div class="card-body d-flex align-items-start gap-3">
            <div
              class="user-avatar rounded-circle d-flex align-items-center justify-content-center text-white fw-bold fs-4"
            >
              {{ getInitials(user.name) }}
            </div>

            <div class="flex-grow-1">
              <div class="fw-bold fs-5 mb-1">
                #{{ user.id }} {{ user.name }}
              </div>
              <div class="small text-muted">
                <div class="mb-1">
                  <i class="bi bi-envelope me-1"></i>{{ user.email }}
                </div>
                <div class="mb-1">
                  <i class="bi bi-person-badge me-1"></i>
                  <strong>{{ user.role.display_name }}</strong>
                </div>
                <div v-if="user.role.name === 'device_maintainer' && user.device" class="mb-1">
                  <i class="bi bi-pc-display me-1"></i>
                  <strong>#{{user.device.id}} - {{ user.device.name }}</strong>
                </div>
                <div>
                  <i class="bi bi-calendar-check me-1"></i>{{ user.created_at }}
                </div>
              </div>
            </div>
          </div>

          <div
            class="card-footer bg-transparent border-top-0 d-flex justify-content-end gap-2"
          >
            <button
              v-if="user.role.name !== 'superuser'"
              class="btn btn-sm btn-outline-danger"
              @click="$emit('user-delete', user)"
              title="Delete"
            >
              <i class="bi bi-trash"></i>
            </button>
          </div>
        </div>
      </div>
    </template>

    <div
      v-if="!loading && users.length === 0"
      class="text-center text-muted mt-4 w-100"
    >
      No users found.
    </div>
  </div>
</template>

<script>
export default {
  name: "UsersList",
  props: {
    users: Array,
    loading: Boolean,
  },
  methods: {
    getInitials(name) {
      if (!name) return "U";
      const parts = name.trim().split(" ");
      return parts.length >= 2
        ? (parts[0][0] + parts[1][0]).toUpperCase()
        : parts[0][0].toUpperCase();
    },
    rolePatternClass(role) {
      return role === "superuser" ? "pattern-superuser" : "pattern-user";
    },
  },
};
</script>

<style scoped>
.user-avatar {
  width: 60px;
  height: 60px;
  background-color: #6c757d;
  flex-shrink: 0;
}

.user-card {
  transition: background 0.3s ease;
  position: relative;
  z-index: 1;
  overflow: hidden;
}

.pattern-superuser {
  background-color: #e9f8f2;
}

.pattern-superuser::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0.05;
  background-image: radial-gradient(circle, #2e7d32 1px, transparent 1px);
  background-size: 12px 12px;
  pointer-events: none;
  z-index: 0;
}

.pattern-user {
  background-color: #ffffff;
}
</style>
